import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { getDataFromAPI ,getCohortListAPI} from '../HandleAPICalls/actions';
import parseResponseToOptions, { parseUserListOptions } from '../../utils/parseResponseToOptions';
import CreateVMCohort from './component';

class CreateVMCohortContainer extends Component {
  constructor() {
    super();
    this.state = {
      name: '',
      areaName: '',
      lat: '',
      lng: '',
      description: '',
      vmCollection: [],
      loading: true,
      vmLoading: true,
      vmList: [],
      userList: [],
      userIdCollection: [],
      userLoading: true,
      cohorts_types:[],
      cohorts_type_id:null,
    };
  }
  componentDidMount() {
    this.props.getDataFromAPI(
      '/vendingmachines/all',
      'GET',
      undefined,
      response => {
        this.setState({ vmList: parseResponseToOptions(response.list), vmLoading: false });
        this.setState({ loading: false });
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch vending machine list');
        this.setState({ loading: false, vmLoading: false });
      }
    );


     this.props.getCohortListAPI(
      "//dashboard/api/v2/admin/vendingmachines/vm-cohorts/seed",
      "GET",
      undefined,
      (response) => {
        console.log("responsetypes-------",response.cohort_types)
        this.setState({
         cohorts_types: parseResponseToOptions(response.cohort_types)
        });
        
      },
      (err) => {
        console.log(err);
       /*  toastr.error(
          "Failed",
          "Unable to fetch vending machine cohort listing"
        ); */
        this.setState({ loading: false });
      }
      
    ); 
 
     this.props.getDataFromAPI(
      '/users/list',
      'GET',
      undefined,
      response => {
        this.setState({ userList: parseUserListOptions(response.list), userLoading: false });
        this.setState({ loading: false });
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch user details');
        this.setState({ loading: false, userLoading: false });
      }
    );
  }
  onChangeOfCohortTypeId=(e,data)=>{
    this.setState({cohorts_type_id:data.value});
    console.log("Hard ware type id -->",this.state.cohorts_type_id)

  }
  onChangeOfName = event => {
    this.setState({ name: event.target.value });
    console.log("this.state.name");
  };

  onChangeOfAreaName = event => {
    this.setState({ areaName: event.target.value });
    console.log("this.state.areaName",event.target.value);
  };

  onChangeOfDescription = event => {
    this.setState({ description: event.target.value });
  };

  onChangeOfLng = event => {
    this.setState({ lng: event.target.value });
    console.log(event.target.value)
  };

  onChangeOfLat = event => {
    this.setState({ lat: event.target.value });
    console.log(event.target.value)
  };

  onChangeOfVM = (event, data) => {
    this.setState({ vmCollection: data.value });
  };

  onChangeOfUser = (event, data) => {
    this.setState({ userIdCollection: data.value });
  };

  handleSubmit = () => {
    console.log("handleSubmit");
    // set loading true
    this.setState({ loading: true });

    const {
      name,
      areaName,
      description,
      lat,
      roleId,
      lng,
      vmCollection,
      userIdCollection,
      cohorts_type_id,
    } = this.state;

    const payload = {
      name,
      areaName,
      description,
      cohortTypeId:cohorts_type_id,
      lat,
    
      lng,
      vmCollection,
      userIdCollection
    };



     if (!name) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Cohort name required');
    }
    if (name.length < 3) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Cohort name');
    }
     if(!cohorts_type_id){
       toastr.warning('Invalid', 'Select Cohort Type ');
    }

    if (!areaName || areaName.length < 3 || areaName.length > 100) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'AreaName name is required, min 3 chars & max 3 chars');
    }
     
    if (!userIdCollection.length) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Please select Users');
    }
    if (!vmCollection.length) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Please select vending machines');
    }
    if (!lng) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Longitude is  required');
    }
    if (!lng.length>=11 || !lng.length>9) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Longitude  is Wrong ');
    }
    if (!lat) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Latitude is  required');
    }
    if (!lat.length>=11 || !lat.length>9) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Latitude is  Wrong');
    }
    
    

    this.props.getDataFromAPI(
      '/vendingmachines/vm-cohorts',
      'POST',
      payload,
      response => {
        toastr.success('Successful', 'Added new cohort');
        this.setState({ loading: false });
        return this.props.history.push('/vendingmachines/cohorts/list');
      },
      err => {
        this.setState({ loading: false });
        toastr.error('Failed', 'Failed to add cohort');
      }
    );
  };

  handleBack = () => {
    return this.props.history.push('/vendingmachines/cohorts/list');
  };

  render() {
    return (
      <CreateVMCohort
        name={this.state.name}
        areaName={this.state.areaName}
        lat={this.state.lat}
        lng={this.state.lng}
        onChangeOfName={this.onChangeOfName}
        onChangeOfAreaName={this.onChangeOfAreaName}
        onChangeOfLat={this.onChangeOfLat}
        onChangeOfLng={this.onChangeOfLng}
        onChangeOfVM={this.onChangeOfVM}
        submitting={this.state.loading}
        dropdownLoading={this.state.loading}
        handleSubmit={this.handleSubmit}
        handleBack={this.handleBack}
        vmLoading={this.state.vmLoading}
        vmList={this.state.vmList}
        userLoading={this.state.userLoading}
        userList={this.state.userList}
        onChangeOfUser={this.onChangeOfUser}
        onChangeOfDescription={this.onChangeOfDescription}
        description={this.state.description}
        cohorts_types={this.state.cohorts_types}
        onChangeOfCohortTypeId={this.onChangeOfCohortTypeId}
        
      />
    );
  }
}

export default withRouter(
  connect(null, {
    getDataFromAPI,
    getCohortListAPI
  })(CreateVMCohortContainer)
);



// WEBPACK FOOTER //
// ./src/Modules/VMCohortCreate/container.jsx